export default "__VITE_ASSET__949de797__"